const messages = {
  title: "Магазин",
  description: "Добре дошли в магазина за награди. Тук можете да осребрите своите Bridgestone Plus точки <br/> за награди от различни категории. Гамата от продукти <br/> се актуализира редовно. Надяваме се да ви хареса да разглеждате.",
  sort: {
    asc: "Сортиране по: Най-ниска цена",
    desc: "Сортиране по: Най-висока цена",
  },
  productSearchBox: {
    from: "точки от",
    to: "точки до",
  },
  noProducts: "Критериите за търсене не дадоха резултати",
  quantity: "Количество",
  search: "Търсене",
  perPage: "Елемента на страница",
  timeUnavailable: "В момента не е налично",
  product: "Продукт",
  cart: {
    pointsPerUnit: "Точки на единица",
    pointsSum: "Сума от точки",
  },
  action: "Действие",
  pointsTotal: "Общо",
  cartRemainPoints: "Оставащи точки в количката",
  shoppingCart: "Количка",
  emptyCart: "Количката е празна.",
  attributes: "Атрибути",
  selectAddressP: "Моля, изберете адрес за доставка",
  orderDelivery: "Адрес за доставка",
  selectedProducts: "Избрани продукти",
  orderSummary: "Преглед на поръчката",
  contactPerson: "Лице за контакт",
  selectedAddress: "Избран адрес",
  order: {
    success: "Благодарим ви! Поръчката ви беше успешна. Ще получите потвърждение в пощенската си кутия след няколко минути.",
    description: "Тук ще намерите преглед на поръчките ви от магазина с награди.",
    info: "Тук ще намерите преглед на поръчките ви от магазина с награди.",
    date: "Дата на поръчка",
    number: "№ поръчка",
    status: {
      created: "Създадена",
      confirm_order: "Потвърди поръчката",
      ready_for_shipment: "Готова за изпращане",
      rejected: "Отхвърлена",
      processed: "Обработена",
      shipped: "Изпратена",
      returned: "Върната",
      finished: "Завършена",
    },
    anyOrder: "Няма поръчки",
    products: "Продукти",
    quantity_short: "бр.",
    itemRemoved: "не може да бъде доставено",
  },
  orders: "Поръчки",
  notEnoughPoints: "Нямате достатъчно налични точки.",
  statusText: "Статус",
  outOfStock: "В момента не е на склад",
  productUnavailable: "Този продукт вече не е наличен.",
  deletedProductsTitle: "Продуктите вече не са налични",
  deletedProductsMessage: "Следните продукти вече не са налични. Премахнете ги от количката, за да продължите.",
  removeSelected: "Премахни избраните",
  clearCart: "Изпразни количката",
  removeSelectedConfirm: "Да премахна ли избраните продукти от количката?",
  clearCartConfirm: "Да премахна ли всички продукти от количката?",
  incompleteAddress: {
    firstName: "Моля, добавете собствено име към адреса за доставка",
    lastName: "Моля, добавете фамилия към адреса за доставка",
    company: "Моля, добавете име на фирма към адреса за доставка",
    street: "Моля, добавете улица и номер към адреса за доставка",
    postalCode: "Моля, добавете пощенски код към адреса за доставка",
    city: "Моля, добавете град към адреса за доставка",
    country: "Моля, добавете държава към адреса за доставка",
    phone: "Моля, добавете телефонен номер към адреса за доставка",
  },
  placeOrder: "Обвързваща поръчка",
  toOrderDelivery: "Продължете към адреса за доставка",
  toOrderSummary: "Към прегледа на поръчката",
  productImg: "Изображение на продукта",
  selectAddressBtn: "Изберете адрес",
  perPgae: "Елемента на страница",
  categories: {
    advertising: {
      title: "Рекламни материали",
      desc: "Участвайте директно тук на платформата и спечелете <br/> 40 допълнителни точки за клуба с награди.",
    },
    rewards: {
      title: "Ексклузивни награди",
      desc: "Открийте бонус офертата в нашия учебен център или на вашата локация.",
    },
    tools: {
      title: "Инструменти за сервиз",
      desc: "Използвайте точките си за обучения на трети страни <br/> и намалете разходите си.",
    },
    trainings: {
      title: "Обучения и курсове",
      desc: "Открийте бонус офертата в нашия учебен център или на вашата локация.",
    },
    salesroom: {
      title: "Търговски зал",
      desc: "Оформете търговския зал и предложете на клиентите си приятен престой.",
    },
    hunter: {
      title: "Hunter",
      desc: "Обменяйте точки за атрактивно сервизно оборудване от Hunter.",
    },
  },
  bestSold: "Най-продавани",
  seasonal: "Сезонни",
  affordable: "Почти готово",
  forPoints: "за {points} точки",
  reachedPoints: "Необходимите точки са достигнати",
  remainingPoints: "Остават {points} точки",
  favoriteProducts: {
    description: "Тук ще намерите запазените продукти.",
  },
  categoryPageDescriptionFallback: "Материали за работилница или други качествени продукти с логото на Bridgestone за вашия бизнес",
  variant: "Избираеми варианти",
};
export default {
  messages,
};
